var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "TooltipNewClick",
        {
          attrs: { TooltipStyle: _vm.TooltipBoxStyle },
          scopedSlots: _vm._u(
            [
              {
                key: "content",
                fn: function () {
                  return [_vm._t("action-buttons")]
                },
                proxy: true,
              },
            ],
            null,
            true
          ),
        },
        [
          _c(
            "svg",
            {
              attrs: {
                width: "21",
                height: "22",
                viewBox: "0 0 21 22",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M10.5002 17.9277C10.9785 17.9277 11.3662 17.54 11.3662 17.0617C11.3662 16.5835 10.9785 16.1958 10.5002 16.1958C10.022 16.1958 9.63428 16.5835 9.63428 17.0617C9.63428 17.54 10.022 17.9277 10.5002 17.9277Z",
                  stroke: "black",
                  "stroke-width": "1.73188",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M10.5002 11.8662C10.9785 11.8662 11.3662 11.4785 11.3662 11.0002C11.3662 10.522 10.9785 10.1343 10.5002 10.1343C10.022 10.1343 9.63428 10.522 9.63428 11.0002C9.63428 11.4785 10.022 11.8662 10.5002 11.8662Z",
                  stroke: "black",
                  "stroke-width": "1.73188",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M10.5002 5.80464C10.9785 5.80464 11.3662 5.41694 11.3662 4.9387C11.3662 4.46045 10.9785 4.07275 10.5002 4.07275C10.022 4.07275 9.63428 4.46045 9.63428 4.9387C9.63428 5.41694 10.022 5.80464 10.5002 5.80464Z",
                  stroke: "black",
                  "stroke-width": "1.73188",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }